<template>
  <b-row>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>Cadastro de Usuário</strong>
        </div>
        <b-alert variant="warning" v-if="getStatusDetail()" show v-html="getStatusDetail()"></b-alert>
        <b-form @submit.stop.prevent>
        <b-form-group
          label="CPF/CNPJ"
          label-for="username">
          <b-form-input id="username" type="text" :disabled="user.id != null" autocomplete="username" v-model="user.username"></b-form-input>
        </b-form-group>

        <b-form-group
          label="Nome"
          label-for="name">
          <b-form-input id="name" type="text" autocomplete="name" v-model="user.name"></b-form-input>
        </b-form-group>
      
        <b-form-group
          label="E-mail"
          label-for="email">
          <b-form-input id="email" type="text" autocomplete="email" v-model="user.email"></b-form-input>
        </b-form-group>

        <b-form-group label="Tipo" label-for="userClass">
          <b-form-select v-model="user.userClass" id="userClass" :disabled="user.id != null">
            <option v-for="userClass in userClasses" v-bind:key="userClass.id" :value="userClass.id">{{userClass.label}}</option>
          </b-form-select>
        </b-form-group>

        <b-form-group
          label="Senha"
          label-for="password"
          v-if="user.userClass == 'user_signer'"
          >
          <b-input-group>
            <b-form-input id="password" :type="pwdInputType" autocomplete="password" v-model="user.password"></b-form-input>
            <b-input-group-append>
              <b-button type="button" size="sm" title="Visualizar senha"
                v-on:click="switchShowPassword()"
              >&nbsp; <i :class="pwdBtnClass"></i> &nbsp;</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      
        <b-form-group label="Grupo" label-for="group">
          <b-form-select v-model="user.billingUserGroup" id="group">
            <option :value="null"></option>
            <option v-for="userGroup in userGroups" v-bind:key="userGroup.id" :value="userGroup">{{userGroup.name}}</option>
          </b-form-select>
        </b-form-group>

        <b-form-group
          label="Expira em"
          label-for="expireAt" v-if="user.id != null">
          <b-form-input id="expireAt" type="date" v-model="user.expireAt" :disabled="expireAtDisabled()"></b-form-input>
        </b-form-group>

        <fieldset class="form-group" v-if="user.initDate">
          <legend class="col-form-label pt-0">Criado em: <strong>{{user.initDate}}</strong></legend>
        </fieldset>

        <fieldset class="form-group" v-if="user.expireAtCertificate">
          <legend class="col-form-label pt-0">Certificado expira em: <strong>{{user.expireAtCertificate}}</strong></legend>
        </fieldset>

        <fieldset class="form-group" v-if="user.inheritedExpireTime">
          <legend class="col-form-label pt-0">Prazo expiração padrão: <strong>{{formatInheritedExpireTime(user.inheritedExpireTime)}}</strong></legend>
        </fieldset>

        <fieldset class="form-group" v-if="user.inheritedAutoRenovation != null">
          <legend class="col-form-label pt-0">Renovação automática padrão: <strong>{{user.inheritedAutoRenovation ? 'Sim' : 'Não'}}</strong></legend>
        </fieldset>

        <b-form-group
          v-if="user.expireTime != null"
          label="Prazo expiração"
          label-for="expireTime"
          >
          <b-form-row>
            <b-col>
              <b-form-input v-model="expireTimeValue" id="expireTime" type="number" max="365" min="1"></b-form-input>
            </b-col>
            <b-col>
              <b-form-select id="expireTimeType"
                v-model="expireTimeType"
                :plain="true"
                :options="selectExpireType">
              </b-form-select>
            </b-col>
          </b-form-row>
        </b-form-group>

        <b-form-group
          v-if="user.autoRenovation != null"
          label=""
          label-for="autoRenovation">
          <b-form-checkbox
            id="autoRenovation"
            v-model="user.autoRenovation"
            name="autoRenovation"
          >
            Renovação automática
          </b-form-checkbox>
        </b-form-group>

        <b-form-group
          label=""
          label-for="disable">
          <b-form-checkbox
            id="disable"
            v-model="user.disable"
            name="disable"
          >
            Bloqueado
          </b-form-checkbox>
        </b-form-group>

        <b-form-group v-if="user.id != null && user.userClass == 'user_corporation'" class="mb-4" label="" label-for="disable">
          <b-link @click="getUserDetail()">Ver status por aplicação</b-link>
          <b-modal ok-only size="xl" id="modal-status" ref="modal" title="Status por aplicação">
            <b-table :hover="true" :striped="true" :bordered="false" :small="false" :fixed="false" responsive="sm" :items="userDetail" :fields="userDetailFields">
              <template slot="applicationUserStatusDesc" slot-scope="data">
                <span v-html="data.item.applicationUserStatusDesc"></span>
              </template>
            </b-table>
          </b-modal>
        </b-form-group>

        <div slot="footer">
          <b-row>
            <b-col sm="12" lg="2">
              <b-button type="submit" variant="primary" @click="save" class="form-control"><i class="fa fa-dot-circle-o"></i> {{this.isRemovido() ? "Recriar" : "Gravar"}}</b-button>&nbsp;
            </b-col>
            <b-col sm="12" lg="2" v-if="!isNew()">
              <b-button type="button" variant="success" @click="renewUser" class="form-control" ><i class="fa fa-recycle"></i> Renovar</b-button>&nbsp;
            </b-col>
            <b-col sm="12" lg="2">
              <b-button type="button" variant="secondary" @click="goBack" class="form-control"><i class="fa fa-arrow-left"></i> Voltar</b-button>&nbsp;
            </b-col>
            <b-col sm="12" lg="2" v-if="!isNew()">
              <b-button type="button" variant="danger" @click="removeUser"  class="form-control"><i class="fa fa-remove"></i> Remover</b-button>
            </b-col>
          </b-row>
        </div>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { requestError, env, isAllowed, validateCPFCNPJ } from '@/shared/utils';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _ from 'underscore';

export default {
  name: 'user',
  components: {
    Loading
  },
  data: () => {
    return {
      user: {
        userClass: "user_corporation"
      },
      loadCount: 0,
      expireTime: {
        value: null,
        type: null
      },
      userGroups: [],
      userClasses: [
        {id: "user_corporation", label: "Corporativo"},
        {id: "user_signer", label: "Assinante PJ"}
      ],
      selectExpireType: [
        { value: 'day', text: 'Dia' },
        { value: 'month', text: 'Mês' },
        { value: 'year', text: 'Ano' }
      ],
      userDetail: [],
      userDetailFields: [
        {key: 'clientId', label: 'Aplicação'},
        {key: 'serviceProviderEnvironment', label: 'Ambiente'},
        {key: 'applicationUserStatusDesc', label: 'Status Usuário'},
        {key: 'applicationStatusDesc', label: 'Status Aplicação'}
      ],
      pwdInputType: 'password',
      pwdBtnClass: 'fa fa-eye',
    }
  },
  mounted() {
    this.getUserGroups(() => {
      this.getUser(this.$route.params.id);
    });
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    },
    expireTimeValue: {
      get: function () {
        let matches = this.getSplitedUserExpireTime(this.user.expireTime);
        if (matches == null) {
          return null;
        }
        return matches[1];
      },
      set: function (val) {
        this.expireTime.value = val;
      }
    },
    expireTimeType: {
      get: function () {
        let matches = this.getSplitedUserExpireTime(this.user.expireTime);
        if (matches == null) {
          return null;
        }
        return matches[2];
      },
      set: function (val) {
        this.expireTime.type = val;
      }
    }
  },
  methods: {
    formatDate(value) {
      if (!value) return null;
      return value.date.split(" ")[0];
    },
    formatInheritedExpireTime(expireTime) {
      let mapSigular = { "year": "ano", "month": "mês", "day": "dia" }
      let mapPlural = { "year": "anos", "month": "meses", "day": "dias" }
      let splited = this.getSplitedUserExpireTime(expireTime);
      if (!splited) {
        return "";
      }
      let val = parseInt(splited[1]);
      let type = splited[2];
      if (val > 1) {
        return val + " " + mapPlural[type];
      } else {
        return val + " " + mapSigular[type];
      }
    },
    getSplitedUserExpireTime(expireTime) {
      if (!expireTime) {
        return null;
      }
      return /\+(\d+)\s([a-z]+)/.exec(expireTime);
    },
    isDisabled(status) {
      return (status & 3) > 0;
    },
    isRemovido() {
      return (this.user.status & 4) > 0;
    },
    isNew() { // Novo ou removido
      return !this.user.id || this.isRemovido();
    },
    expireAtDisabled(role) {
      let disabled = this.user.id != null && !isAllowed('corporation_manager');
      return disabled;
    },
    getStatusDetail() {
      var details = this.getStatusDetailList(this.user.status, false);
      if (!details.length) {
        return null;
      }
      details = details.map(itm => `<b>${itm}</b>`);
      return `O usuário está com o status ${details.join(", ")}.`;
    },
    getStatusDetailList(status, disabledUserInclude) {
      // const STATUS_ENABLED = 0;
      // const STATUS_DISABLED_USER = 1;
      // const STATUS_DISABLED_CORP = 2;
      // const STATUS_REMOVED = 4;
      // const STATUS_LOCKED = 8;
      var details = [];
      if (disabledUserInclude && (status & 1) > 0) {
        details.push("bloqueado pelo próprio usuário");
      }
      if ((status & 2) > 0) {
        details.push("bloqueado pela corporação");
      }
      if ((status & 4) > 0) {
        details.push("removido");
      }
      if ((status & 8) > 0) {
        details.push("bloqueado");
      }
      return details;
    },
    getUser(id) {
      if (!id) {
        return;
      }
      var _this = this;
      this.loadCount++;
      axios
        .get(`${env.urlBillingApi}/corporation-user/${id}`)
        .then(function(response) {
          response.data.expireAt = _this.formatDate(response.data.expireAt);
          response.data.expireAtCertificate = _this.formatDate(response.data.expireAtCertificate);
          response.data.initDate = _this.formatDate(response.data.initDate);
          response.data.disable = _this.isDisabled(response.data.status);
          _this.user = response.data;
          if (response.data.billingUserGroup) {
            _this.user.billingUserGroup = _.findWhere(_this.userGroups, {id: response.data.billingUserGroup.id})
          }
        })
        .catch(function(error) {
          // requestError(error);
          _this.$toasted.error(error.response.data.detail.message, {
            theme: "bubble",
            position: "top-right",
            duration: 5000
          });
        })
        .finally(() => {
          _this.loadCount--;
        });
    },
    getUserDetail() {
      if (!this.user || !this.user.username) {
        return;
      }
      this.loadCount++;
      this.userDetail = [];
      axios
        .get(`${env.urlBillingApi}/user-deep-detail?username=${this.user.username}`)
        .then((response) => {
          response.data.forEach(itm => {
            itm.applicationStatusDesc = itm.applicationStatus ? "Habilitado" : "Desabilitado";
            itm.applicationUserStatusDesc = !itm.applicationUserStatus ? "Habilitado" : this.getStatusDetailList(itm.applicationUserStatus, true).join('<br>');
            this.userDetail.push(itm);
          });
          this.$nextTick(() => {
            this.$refs.modal.show();
          });
        })
        .catch((error) => {
          // requestError(error);
          this.$toasted.error(error.response.data.detail.message, {
            theme: "bubble",
            position: "top-right",
            duration: 5000
          });
        })
        .finally(() => {
          this.loadCount--;
        });
    },
    goBack() {
      this.$router.replace({path: '/users'});
      // this.$router.go(-1);
    },
    save() {
      if (!this.validateSave()) {
        return;
      }
      var _this = this;
      this.loadCount++;
      if (this.expireTime.type && this.expireTime.value) {
        this.user.expireTime = `+${this.expireTime.value} ${this.expireTime.type}`;
      }
      var req;
      if (this.isNew()) { // Novo ou removido
        req = axios.post(`${env.urlBillingApi}/corporation-user`, this.user);
      } else {
        req = axios.put(`${env.urlBillingApi}/corporation-user/${this.user.id}`, this.user);
      }
      req.then(function(response) {
        var user = response.data;
        console.log(user);
        _this.$bvModal.msgBoxOk('Usuário gravado com sucesso!')
          .then(value => {
            _this.$router.replace({path: '/users'});
          })
          .catch(function(error){
            _this.$toasted.error(error.response.data.detail, {
              theme: "bubble",
              position: "top-right",
              duration: 5000
            });
          });
      })
      .catch(function(error) {
        _this.$toasted.error(error.response.data.detail, {
          theme: "bubble",
          position: "top-right",
          duration: 5000
        });
      })
      .finally(() => {
        _this.loadCount--;
      });
    },
    validateSave() {
      if (this.user.userClass == 'user_signer' && (!this.user.password || this.user.password.length < 4)) {
        this.$bvModal.msgBoxOk('A senha do usuário deve possuir 4 ou mais caracteres.')
          .then()
          .catch((error) => {
            this.$toasted.error(error.response.data.detail, { theme: "bubble", position: "top-right", duration: 5000 });
          });
        return false;
      }
      this.user.username = this.user.username.replace(/[^\da-zA-Z]/g, "").toUpperCase();
      if (!validateCPFCNPJ(this.user.username)) {
        this.$bvModal.msgBoxOk('CPF ou CNPJ inválido.')
          .then()
          .catch((error) => {
            this.$toasted.error(error.response.data.detail, { theme: "bubble", position: "top-right", duration: 5000 });
          });
        return false;
      }
      return true;
    },
    removeUser() {
      var _this = this;
      var id = this.user.id;
      if (!id) return;
      this.$bvModal.msgBoxConfirm('Deseja realmente excluir o registro?', {
        okVariant: 'danger',
        okTitle: 'Sim',
        cancelTitle: 'Não',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (value) {
          _this.loadCount++;
          axios
            .delete(`${env.urlBillingApi}/corporation-user/${id}`)
            .then(function(response) {
              console.log(response);
              _this.$bvModal.msgBoxOk('Usuário excluído com sucesso!')
                .then(value => {
                  _this.$router.replace({path: '/users'});
                })
                .catch(console.error);
            })
            .catch(function(error) {
              requestError(error);
            })
            .finally(() => {
              _this.loadCount--;
            });
        }
      }).catch(alert);
    },
    renewUser() {
      var _this = this;
      var id = this.user.id;
      if (!id) return;
      this.$bvModal.msgBoxConfirm('Deseja realmente renovar a licença desse usuário?', {
        okVariant: 'success',
        okTitle: 'Sim',
        cancelTitle: 'Não',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (value) {
          _this.loadCount++;
          axios
            .patch(`${env.urlBillingApi}/corporation-user/${id}`)
            .then(function(response) {
              _this.user.expireAt = _this.formatDate(response.data.expireAt);
              _this.user.disable = response.data.disable;
              _this.$bvModal.msgBoxOk('Usuário renovado com sucesso!');
            })
            .catch(function(error) {
              requestError(error);
            })
            .finally(() => {
              _this.loadCount--;
            });
        }
      }).catch(alert);
    },
    getUserGroups(callback) {
      this.loadCount++;
      axios
        .get(`${env.urlBillingApi}/user-group`)
        .then((response) => {
          this.userGroups = response.data._embedded.user_group;
          callback();
        })
        .catch((error) => requestError(error))
        .finally(() => this.loadCount--);
    },
    switchShowPassword() {
      if (this.pwdInputType == 'password') {
        this.pwdInputType = 'text';
        this.pwdBtnClass = 'fa fa-eye-slash';
      } else {
        this.pwdInputType = 'password';
        this.pwdBtnClass = 'fa fa-eye';
      }
    }
  }
}
</script>
